/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PhotoDocTask } from './PhotoDocTask';
export type PhotoDocHistoryEvent = {
    readonly id: string;
    event_type: PhotoDocHistoryEvent.event_type;
    occurred_at: string;
    author_name: string | null;
    work_package: {
        id: string;
        name: string;
        construction_site_number: string;
    } | null;
    task: PhotoDocTask | null;
    manager_name: string | null;
    photo_name: string | null;
};
export namespace PhotoDocHistoryEvent {
    export enum event_type {
        CREATE = 'create',
        ASSIGNED_WORK_PACKAGE = 'assigned_work_package',
        ASSIGNED_MANAGER = 'assigned_manager',
        DELETED = 'deleted',
        PHOTO_DELETED = 'photo_deleted',
    }
}

